import type { ComponentPropsWithoutRef } from "react";
import handwrittenWordmark from "../assets/harness-handwritten-wordmark.png";

/**
 * The canonical Harness wordmark.
 *
 * Use this component for visible Harness branding on every new page. Do not
 * substitute styled text: the custom cursive artwork is the product logo.
 */
export function HarnessWordmark({ alt = "", ...props }: ComponentPropsWithoutRef<"img">) {
  return <img {...props} src={handwrittenWordmark} alt={alt} draggable={false} />;
}
